export default {
    state: {
        currentUser: {
            role: localStorage.getItem('role')
        },
        token: localStorage.getItem('api-token'),
        filters: localStorage.getItem('floisvos-admin-filters'),
        sortOption: localStorage.getItem('floisvos-admin-sortOption'),
        sortOrder: localStorage.getItem('floisvos-admin-sortOrder')
    },
    mutations: {
        setToken(state, value) {
            state.token = value
        },
        setCurrentUser(state, value) {
            state.currentUser = value
            state.loggedIn = true
        },
        setFilters(state, value) {
            state.filters = JSON.stringify(value)
        },
        setSortOption(state, value) {
            state.sortOption = JSON.stringify(value)
        },
        setSortOrder(state, value) {
            state.sortOrder = value
        }
    },
    actions: {
        setSortOrder({ commit }, sortOrder) {
            localStorage.setItem('floisvos-admin-sortOrder', sortOrder)
            commit('setSortOrder', sortOrder)
        },
        setSortOption({ commit }, sortOption) {
            localStorage.setItem('floisvos-admin-sortOption', JSON.stringify(sortOption))
            commit('setSortOption', sortOption)
        },
        setFilters({ commit }, filters) {
            localStorage.setItem('floisvos-admin-filters', JSON.stringify(filters))
            commit('setFilters', filters)
        },
        logout({ dispatch }) {
            dispatch('setCurrentUser', null)
            dispatch('setToken', null)
        },
        login({ dispatch }, resp) {
            if (resp.data.token) {
                dispatch('setToken', resp.data.token)
                dispatch('setCurrentUser', {
                    role: resp.data.role
                })
            }
        },
        setToken({ commit }, token) {
            if (token) {
                localStorage.setItem('api-token', token)
                commit('setToken', token)
            } else {
                localStorage.removeItem('api-token')
                commit('setToken', null)
            }
        },
        setCurrentUser({ commit }, currentUser) {
            if (currentUser) {
                localStorage.setItem('role', currentUser.role)
                commit('setCurrentUser', currentUser)
            } else {
                localStorage.removeItem('role')
                commit('setCurrentUser', null)
            }
        }
    },
    getters: {
        getSortOption: state => JSON.parse(state.sortOption),
        getSortOrder: state => state.sortOrder,
        getFilters: state => JSON.parse(state.filters),
        getToken: state => state.token,
        currentUser: (state) => {
            if (state.currentUser && !state.currentUser.role) {
                return null
            }
            return state.currentUser
        },
        isLoggedIn(state) {
            return state.token !== null
        }
    }
}
